export default {
  apiKey: "AIzaSyBOlkjGOJU1nnyflUW7y0OoGe4x9xXoGX8",
  authDomain: "codechat-8f439.firebaseapp.com",
  projectId: "codechat-8f439",
  storageBucket: "codechat-8f439.appspot.com",
  messagingSenderId: "436962222114",
  appId: "1:436962222114:web:c8ad32d6ed27650679aa7b"
};